import { render } from "./DashboardPageLayout.vue?vue&type=template&id=e321b1f2"
import script from "./DashboardPageLayout.vue?vue&type=script&lang=js"
export * from "./DashboardPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__